<template>
  <div>
    <AppDialog
      title="Disconnect SSO configuration"
      :show="showDialog"
      size="medium"
      append-to-body
      position="centered"
      @close="closeAllDialogs"
    >
      <template #default>
        <p class="text-lighter">Are you sure you want to disconnect this SSO configuration?</p>

        <div class="sso-disconnect-danger">
          <i class="fa fa-warning"></i>
          <ul class="mb-0 pl-20">
            <li>
              Disconnecting SSO configuration will require members to log in with their Hubstaff email and password
            </li>
            <li>Members who don't know their Hubstaff password will need to reset it</li>
            <li>
              Two-factor authentication may no longer be enforced. Make sure it is enabled to keep your account secure.
              <a
                :href="mfaSettingsUrl"
                class="text-blue"
              >
                Go to 2FA settings
              </a>
            </li>
          </ul>
        </div>
      </template>

      <template #footer>
        <div class="footer">
          <div class="buttons">
            <AppButton
              class="text-lighter"
              @click="closeAllDialogs"
            >
              Cancel
            </AppButton>
            <AppButton
              type="primary"
              @click="disconnectConfig"
            >
              Disconnect
            </AppButton>
          </div>
        </div>
      </template>
    </AppDialog>
  </div>
</template>

<script>
import { SSOResource } from '~/resources';

export default {
  name: 'DisconnectConfig',
  props: {
    organizationId: {
      type: Number,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    mfaSettingsUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showDialog: this.show,
    };
  },
  methods: {
    loadInitialData() {
      this.showDialog = true;
    },
    closeAllDialogs() {
      this.showDialog = false;
      this.$emit('close');
    },
    async disconnectConfig() {
      if (window.confirm('Are you sure you want to disconnect your current SSO configuration?')) {
        const params = { organizationId: this.organizationId };

        SSOResource.destroy(params, null, { abortReload: true })
          .then((response) => {
            if (response && response.success) {
              this.$appMessage('SSO configuration has been disconnected', 'success');
              this.closeAllDialogs();
              window.location.reload();
            } else {
              this.$appMessage('Failed to disconnect SSO configuration. Please, try again later.', 'error');
            }
          })
          .catch((error) => {
            console.error('Failed to delete SSO configuration', error);
          });
      }
    },
  },
};
</script>
